// extracted by mini-css-extract-plugin
module.exports = {"list":"information-panel-module--list--2qbtc","button":"information-panel-module--button--3rzyR"};